export default __webpack_public_path__ + "static/media/fun_jul2020_pt1.fe21626f.bmp";